export type SocialLinkPlatform = 'facebook' | 'instagram' | 'website';

export type SocialLinkItem = {
  platform: SocialLinkPlatform;
  label: string;
  url: string;
};

export const ADULTING_WEBSITE_URL = 'https://adultingapp.uk';

export const ADULTING_SOCIAL_LINKS: SocialLinkItem[] = [
  {
    platform: 'facebook',
    label: 'Visit our Facebook Page',
    url: 'https://facebook.com/adultinguk',
  },
  {
    platform: 'instagram',
    label: 'Follow Adulting on Instagram',
    url: 'https://www.instagram.com/adultingappuk/',
  },
  {
    platform: 'website',
    label: 'Visit adultingapp.uk',
    url: ADULTING_WEBSITE_URL,
  },
];
